import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';

@Injectable()
export class MasterListService {

  constructor(private _http: HttpClient) { }


  getLanguageList(): any {
    return this._http.get(environment.APIEndpoint + 'api/Language/GetLanguageList')
      .map((res) => res)
      .catch(this._errorHandler);
  }


  getAllEyRoleList(): any {
    return this._http.get(environment.APIEndpoint + 'api/MasterList/GetAllEyRoleList')
      .map((res) => res)
      .catch(this._errorHandler);
  }

  addEyRoleList(mappedRoles: any) {
   // const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this._http.post(environment.APIEndpoint + 'api/MasterList/AddEyRoleList', mappedRoles)
      .map((res: Response) => res);
  }

  _errorHandler(error: Response) {
    return Observable.throw(error || 'Server Error');
  }

  deleteMasterList(roleMappingId:any): any {
    return this._http.delete(environment.APIEndpoint + 'api/MasterList/DeleteMasterList?mappingId='+roleMappingId)
      .map((res) => res)
      .catch(this._errorHandler);
  }
}
